// extracted by mini-css-extract-plugin
module.exports = {"Ministerio":"Ministerio_Ministerio__34KWp"};